import { oriasQueryKeys } from "@src/data/infoSocieteOrias/hook/oriasQuery.keys";
import { GatewayInfoSocieteOriasApi } from "@src/data/infoSocieteOrias/infoSocieteOrias.api";
import { useQuery } from "@tanstack/react-query";

export function useInfoSocieteOriasQuery(siren: string) {
  return useQuery({
    queryKey: oriasQueryKeys.detail(siren),
    queryFn: () => GatewayInfoSocieteOriasApi.getInfoSocieteOriasBySiren(siren),
    staleTime: Infinity,
    enabled: !!siren,
    meta: {
      errorMessage: `Impossible de récupérer les informations ORIAS pour le SIREN ${siren}`,
    },
  });
}
